export default function Chat() {
  return (
    <div className="app-page">
      <h1 className="app-page-title">聊天</h1>
      <div className="app-page-card">在此接入聊天功能。</div>
    </div>
  )
}
